import { call, takeLatest } from "redux-saga/effects";
import {
  CFA_DETAIL,
  CFA_DISTRIBUTOR_LIST,
  CFA_HEAD_QUATERS_LIST,
  CFA_LIST,
  CFA_VERSION_DETAIL,
  CFA_VERSION_LIST,
  CREATE_CFA,
  DELETE_CFA,
  EDIT_CFA,
  ENALBE_DISABLE_CFA,
  SEND_CFA_MAIL,
} from "../actions/types";
import {
  cfaCreateApi,
  cfaDeleteApi,
  cfaDistributorListApi,
  cfaEditApi,
  cfaEnableDisabletApi,
  cfaHeadQuaterListApi,
  cfaListApi,
  cfaSendMailApi,
  cfaVersionDetailApi,
  cfaVersionListApi,
  cfaViewApi,
} from "../apis/cfaApi";

export function* cfaListWorker(action) {
  try {
    const res = yield call(cfaListApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* cfaCreateWorker(action) {
  try {
    const res = yield call(cfaCreateApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* cfaEditWorker(action) {
  try {
    const res = yield call(cfaEditApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
      console.log(res.data);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* cfaDetailWorker(action) {
  try {
    const res = yield call(cfaViewApi, {
      cfa_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* cfaVersionWorker(action) {
  try {
    const res = yield call(cfaVersionListApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* cfaVersionDetailWorker(action) {
  try {
    const res = yield call(cfaVersionDetailApi, {
      cfa_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fetchCfaHeadQuaterListWorker(action) {
  try {
    const res = yield call(cfaHeadQuaterListApi);
    if (res.status == "200") {
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fetchCfaDistributorListWorker(action) {
  try {
    const res = yield call(cfaDistributorListApi);
    if (res.status == "200") {
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.firm_name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* cfaEnableDisableWorker(action) {
  try {
    const res = yield call(cfaEnableDisabletApi, {
      cfa_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* cfaDeleteWorker(action) {
  try {
    const res = yield call(cfaDeleteApi, {
      cfa_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* cfaSendMailWorker(action) {
  try {
    const res = yield call(cfaSendMailApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* cfaListWatcher() {
  yield takeLatest(CFA_LIST, cfaListWorker);
}
export function* cfaCreateWatcher() {
  yield takeLatest(CREATE_CFA, cfaCreateWorker);
}
export function* cfaEditWatcher() {
  yield takeLatest(EDIT_CFA, cfaEditWorker);
}
export function* cfaDetailWatcher() {
  yield takeLatest(CFA_DETAIL, cfaDetailWorker);
}
export function* cfaVersionWatcher() {
  yield takeLatest(CFA_VERSION_LIST, cfaVersionWorker);
}
export function* cfaVersionDetailWatcher() {
  yield takeLatest(CFA_VERSION_DETAIL, cfaVersionDetailWorker);
}
export function* fetchCfaHeadQuaterListWatcher() {
  yield takeLatest(CFA_HEAD_QUATERS_LIST, fetchCfaHeadQuaterListWorker);
}
export function* fetchCfaDistributorListWatcher() {
  yield takeLatest(CFA_DISTRIBUTOR_LIST, fetchCfaDistributorListWorker);
}
export function* cfaEnableDisableWatcher() {
  yield takeLatest(ENALBE_DISABLE_CFA, cfaEnableDisableWorker);
}
export function* cfaDeleteWatcher() {
  yield takeLatest(DELETE_CFA, cfaDeleteWorker);
}
export function* cfaSendMailWatcher() {
  yield takeLatest(SEND_CFA_MAIL, cfaSendMailWorker);
}
